var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 0.75H1.25C0.918479 0.75 0.600537 0.881696 0.366117 1.11612C0.131696 1.35054 0 1.66848 0 2V11C0 11.3315 0.131696 11.6495 0.366117 11.8839C0.600537 12.1183 0.918479 12.25 1.25 12.25H10.25C10.5815 12.25 10.8995 12.1183 11.1339 11.8839C11.3683 11.6495 11.5 11.3315 11.5 11V2C11.5 1.66848 11.3683 1.35054 11.1339 1.11612C10.8995 0.881696 10.5815 0.75 10.25 0.75ZM10 10.75H1.5V2.25H10V10.75Z",
    fill: "#04245C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSquare);
export default __webpack_public_path__ + "static/media/cancel_square.a180841f369ce38302fce9ead4abdbed.svg";
export { ForwardRef as ReactComponent };